import React, { useState } from "react";
import axios from "axios";
import { Modal, Col } from "reactstrap";

const CHUNK_SIZE = 20 * 1024 * 1024; // 20 Mo par morceau

const generateUploadId = () =>
    (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^a-zA-Z0-9_-]/g, "");

const NewApkModal = ({ onApkAdded }) => {
    const [open, setOpen] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    const [form, setForm] = useState({
        modele: "",
        description: "",
        nom: "",
        version: ""
    });
    const [file, setFile] = useState(null);

    const toggle = () => setOpen(!open);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0] || null);
    };

    const resetForm = () => {
        setForm({ modele: "", description: "", nom: "", version: "" });
        setFile(null);
    };

    const handleSubmit = async () => {
        if (!form.modele || !form.nom || !form.version) {
            return alert("Modèle, nom et version sont requis !");
        }
        if (!file) {
            return alert("Veuillez sélectionner un fichier APK !");
        }
        if (!file.name.toLowerCase().endsWith(".apk")) {
            return alert("Le fichier sélectionné doit être un fichier .apk");
        }

        setUploading(true);
        setProgress(0);
        try {
            const uploadId = generateUploadId();
            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

            for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                const start = chunkIndex * CHUNK_SIZE;
                const chunk = file.slice(start, start + CHUNK_SIZE);

                const chunkFormData = new FormData();
                chunkFormData.append("uploadId", uploadId);
                chunkFormData.append("chunkIndex", chunkIndex);
                chunkFormData.append("chunk", chunk);

                await axios.post("/api/upload/apk-chunk", chunkFormData, {
                    withCredentials: true,
                    headers: { "Content-Type": "multipart/form-data" },
                });

                setProgress(Math.round(((chunkIndex + 1) / totalChunks) * 100));
            }

            await axios.post("/api/upload/apk-chunk-complete", {
                uploadId,
                totalChunks,
                modele: form.modele,
                description: form.description,
                nom: form.nom,
                version: form.version,
            }, { withCredentials: true });

            onApkAdded();
            resetForm();
            toggle();
        } catch (err) {
            console.error(err.response?.data || err);
            alert(err.response?.data?.error || "Erreur lors de l'ajout de l'APK");
        } finally {
            setUploading(false);
            setProgress(0);
        }
    };

    return (
        <>
            <button
                title="Ajouter un nouvel APK"
                className="btn btn-outline-primary" onClick={toggle}>
                <i className="mdi mdi-plus-circle-outline fs-4 py-0 align-middle"></i> Ajouter un APK
            </button>

            <Modal isOpen={open} toggle={toggle}>
                <div className="modal-header">
                    <h5 className="modal-title">Nouvel APK</h5>
                    <button className="close" onClick={toggle}>
                        &times;
                    </button>
                </div>

                <div className="modal-body">
                    {[
                        { label: "Modèle supporté", name: "modele" },
                        { label: "Description", name: "description" },
                        { label: "Nom", name: "nom" },
                        { label: "Version", name: "version" }
                    ].map(({ label, name, type }) => (
                        <Col md={12} key={name}>
                            <div className="form-floating mb-3">
                                <input
                                    type={type || "text"}
                                    className="form-control"
                                    name={name}
                                    value={form[name]}
                                    onChange={handleChange}
                                />
                                <label>{label}</label>
                            </div>
                        </Col>
                    ))}

                    <Col md={12}>
                        <div className="mb-3">
                            <label className="form-label">Fichier APK</label>
                            <input
                                type="file"
                                accept=".apk"
                                className="form-control"
                                onChange={handleFileChange}
                            />
                        </div>
                    </Col>
                </div>

                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={toggle} disabled={uploading}>
                        Annuler
                    </button>
                    <button className="btn btn-primary" onClick={handleSubmit} disabled={uploading}>
                        {uploading ? `Envoi... ${progress}%` : "Ajouter"}
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default NewApkModal;

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license
